module.exports = window["MaterialUI"].ListItemText;